"use client";

import { c as _c } from "react/compiler-runtime";
import { Google, Microsoft } from "@mui/icons-material";
import React, { useCallback } from "react";
import CalendarModalLayout from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/calendar/calendar-modal-layout";
import Button from "@/components/button";
import useMobile from "@/hooks/use-mobile";
import { useModalStore } from "@/stores/modal-store";
interface SubscribeCalendarButtonProps {
  clubSlug: string;
}
const SubscribeCalendarButton: React.FC<SubscribeCalendarButtonProps> = t0 => {
  const $ = _c(11);
  const {
    clubSlug
  } = t0;
  const {
    open: openModal
  } = useModalStore();
  let t1;
  if ($[0] !== clubSlug || $[1] !== openModal) {
    t1 = async () => {
      openModal({
        component: <CalendarModalLayout clubSlug={clubSlug} />
      });
    };
    $[0] = clubSlug;
    $[1] = openModal;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onButtonClick = t1;
  const isMobile = useMobile();
  let t2;
  if ($[3] !== isMobile) {
    t2 = !isMobile && <span>Ajouter à mon calendrier</span>;
    $[3] = isMobile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex gap-2"><Google /><Microsoft /></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="flex justify-center items-center xl:gap-6 gap-4 px-10">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onButtonClick || $[9] !== t4) {
    t5 = <Button variant="filled" colorTheme="secondary" onClick={onButtonClick} className="w-full p-5 rounded-md">{t4}</Button>;
    $[8] = onButtonClick;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default SubscribeCalendarButton;